import { BoxWithPointer, Overlay } from '@usap/widgets'
import styled, { css } from 'styled-components'
import { ResponsiveBox, Box, Button } from '@usap/uicomponents'

const validButtonStyle = css`
  background-color: #f4eb27;
  color: #2e4787;
  border-color: #f4eb27;
  transition: all 0.3s ease 0s;
  width: 125px;
`
const notValidButtonStyle = css`
  cursor: default;
  opacity: 0.5;
  pointer-events: none;
  width: 125px;
`

export const ButtonNoFocus = styled(Button)`
  border-color: white;
  height: 46px;
  font-weight: 700;
  &:hover {
    box-shadow: none;
  }
  ${props => (props.isValid ? validButtonStyle : notValidButtonStyle)}
`

export const BoxNoFocus = styled(Box)`
  button {
    box-shadow: 0 0 0px 0px transparent;
  }
`

export const FixedOverlay = styled(Overlay)`
  position: fixed;
`

export const SelectorContainer = styled(Box)`
  ${props => props.theme.mediaQuery.down('tablet-landscape')} {
    margin: 0 auto ${props => props.theme.global.edgeSize.large} auto;
  }

  @media (max-width: 768px) {
    margin: 0 auto ${props => props.theme.global.breakpoints.small.edgeSize.large} auto;
  }

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    padding: 0px;
    margin: 0px auto;
    position: relative;
    ${props => props.isHomePage && 'top: -38px;'}
  }
`

export const SelectorWrap = styled(Box)`
  flex-direction: column;
  opacity: 1;
  margin: 0px auto;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    flex-direction: row;
    align-items: center;
    height: 72px;
    border-radius: 50px;
  }

`

export const SelectorTitleWrap = styled(Box)`
  width: 100%;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    width: 288px;
  }
`

export const SelectorTitle = styled(Box)`
  align-self: center;
  ${props => props.theme.mediaQuery.down('tablet-landscape')} {
    padding: 16px 0;
  }

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    padding-left: ${props => props.theme.global.edgeSize.small};
  }
  
`

export const SelectorIconWrap = styled(Box)`
  border: solid 2px ${props => props.theme.global.colors.white};

  ${props => props.theme.mediaQuery.down('tablet-landscape')} {
    display: none;
  }
`

export const SelectorContentWrap = styled(ResponsiveBox)`
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  width: 100%;
  padding: 0px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    flex-direction: row;
    padding: 0 ${props => props.theme.global.edgeSize.small};
  }
`

export const SelectorOptionsWrap = styled(Box)`
  flex-direction: column;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    flex-direction: row;
  }
`

export const SelectorActionsWrap = styled(Box)`
  padding: 16px 0;

  ${props => props.theme.mediaQuery.down('tablet-landscape')} {
    width: 100%;
  }
  
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    min-width: 126px;
    padding: 0px;
  }

`

export const SelectorGoActionWrap = styled(Box)`
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    margin: 0px;
  }
`

export const OverlayCloseWrap = styled.div`
  position: absolute;
  right: 0;
  top: -35px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    right: -10px;
    top: -45px;
  }

`

export const OverlayCloseButton = styled(BoxWithPointer)`
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    margin: 0 ${props => props.theme.global.edgeSize.xsmall}
  }
`
